<div class="mode" [class.active]="dark" (click)="layoutToggle()">
    <app-comman-svg-icon [icon]="'moon'"></app-comman-svg-icon>
</div>